import { $tag, TaggedEnum, TaggedEnumTypeDescriptor } from '@suntex.core/types';

export class InvalidEnumError<
  Tag extends string,
  Desc extends TaggedEnum<Tag>,
> extends Error {
  constructor(
    readonly desc: TaggedEnumTypeDescriptor<Desc>,
    readonly key: number | string,
    readonly keyProperty: 'value' | 'slug' = 'value',
  ) {
    const enumName = desc[$tag] as string;
    super(`No ${enumName} with ${keyProperty}: "${key}"`);
  }
}
